<ng-container *ngIf="readiness && displayReadiness">
  <div [ngClass]="['readinessBox', readiness.color]">
    <mat-icon [ngClass]="'readinessIcon'" [inline]="true">{{readiness.icon}}</mat-icon>
    <span *ngIf="displayReadinessText" class="cursorsText">{{readiness.text}}</span>
  </div>
</ng-container>
